import {useEffect, useMemo} from 'react';

import {useDatadogRum} from '../../../util/datadog/datadogRum';
import {
  useStatsigGateBackendLineConstruction,
  useStatsigGateBackendLineConstructionMultiMetric,
  useStatsigGateBackendLineConstructionSmoothing,
  useStatsigGateBackendLineConstructionSystemMetrics,
} from '../../../util/rampFeatureFlags';

export type BackendLineConstructionFlags = {
  canUseBackendLineConstruction: boolean;
  canUseBackendLineConstructionMultiMetric: boolean;
  canUseBackendLineConstructionSmoothing: boolean;
  canUseBackendLineConstructionSystemMetrics: boolean;
};

export const useBackendLineConstruction = (
  entityName: string
): BackendLineConstructionFlags => {
  const ddRum = useDatadogRum();
  const canUseBackendLineConstruction =
    useStatsigGateBackendLineConstruction(entityName);
  const canUseBackendLineConstructionMultiMetric =
    useStatsigGateBackendLineConstructionMultiMetric(entityName);
  const canUseBackendLineConstructionSmoothing =
    useStatsigGateBackendLineConstructionSmoothing(entityName);
  const canUseBackendLineConstructionSystemMetrics =
    useStatsigGateBackendLineConstructionSystemMetrics(entityName);

  // track
  useEffect(() => {
    ddRum.addAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
      useBackendLineConstructionMultiMetric:
        canUseBackendLineConstructionMultiMetric,
      useBackendLineConstructionSmoothing:
        canUseBackendLineConstructionSmoothing,
      useBackendLineConstructionSystemMetrics:
        canUseBackendLineConstructionSystemMetrics,
    });
  }, [
    canUseBackendLineConstruction,
    canUseBackendLineConstructionMultiMetric,
    canUseBackendLineConstructionSmoothing,
    canUseBackendLineConstructionSystemMetrics,
    ddRum,
  ]);

  return useMemo(
    () => ({
      canUseBackendLineConstruction,
      canUseBackendLineConstructionMultiMetric,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionSystemMetrics,
    }),
    [
      canUseBackendLineConstruction,
      canUseBackendLineConstructionMultiMetric,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionSystemMetrics,
    ]
  );
};
